import moment from 'moment/moment';

export const isEffectiveDateValid = (date?: string): boolean => {
  if (!date) {
    return false
  }

  return moment(date).isValid() && moment(date).isAfter(moment('01-01-2021'))// && moment(date).isBetween(moment('01-01-2021'), moment().add(1, 'year').startOf('year'))
}
